module.exports = __webpack_public_path__ + "static/media/tiny1.c181e14c.png";